import React from "react";
import doneSVG from "../../assets/icons/done.svg";

import "./styles.scss";

const ThankYou = () => (
  <div className="thank-you-container">
    <img src={doneSVG} alt="success" />
    <h1>Thank You</h1>
    <h6>Your contract has been submitted successfully.</h6>
  </div>
);

export default ThankYou;
